import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Main from "./meetingRoom/Main";
import Login from "./Login";
import Insert from "./Insert";
import ButtonAppBar from "./ButtonAppBar";
import MainPage from "./MainPage";
import Dashboard from "./sams/DashBoard/DashBoard";
import TimeStream from "./sams/DashBoard/TimeStream";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/aact" element={<ButtonAppBar />} />
        <Route path="/reservation" element={<Main />} />
        <Route path="/" element={<Login />} />
        <Route path="/reservation/insert" element={<Insert />} />
        <Route path="/sams/cimplist" element={<MainPage />} />
        <Route path="/sams/dashboard" element={<MainPage />} />
        <Route path="/time" element={<TimeStream />} />
        <Route path="/sams/inoutlive" element={<MainPage />} />
        <Route path="/sams/dashboardPop" element={<Dashboard />} />
        <Route path="/sams/inoutinlive" element={<MainPage />} />
        <Route path="/sq/holdlist" element={<MainPage />} />
        <Route path="/edi/livelist" element={<MainPage />} />
        <Route path="/sams/sphList" element={<MainPage />} />
        {/* <Route path="/dpr/dprlist" element={<MainPage />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
